import { createSetting, useDialog } from '@shopex/finder'
import { MessageBox } from 'element-ui'
import { batchDelete, setGovItems} from '../api'


const commonAction = [
  { label: '取消', key: 'close', size: 'default' },
  { label: '提交', key: 'save', type: 'primary', size: 'default' }
]

export const tableSetting = (vm) => createSetting({
  search: [
    {
      name: '店铺名称',
      key: 'name',
    }
  ],
  columns: [
    {
      name: '门店',
      key: 'name',
      minWidth: 150,
      render: (h, {row}) => {
        return (
          <div>
            <div class="goods-title">
              {row?.name}
            </div>
            <div style={{ color: '#888', fontSize: '13px' }}>
              <div>
                Apple ID：{row.shop_code}
              </div>
              <div>
                地址：{row.address}
              </div>
            </div>
          </div>
        )
      }
    },
    {
      name: '所属经销商',
      key: 'dealer_info',
      minWidth: 150,
      render: (h, {row}) => {
        return (
          <div>
            <div class="goods-title">
              {row?.dealer_info?.name}
            </div>
            <div style={{ color: '#888', fontSize: '13px' }}>
              <div>
                HQID：{row?.dealer_info?.dealer_hqid}
              </div>
            </div>
          </div>
        )
      }
    },
    {
      name: '国补商品',
      key: 'online_subsidy_goods_count',
      minWidth: 150,
      render: (h, {row}) => {
        if (row.subsidy_type == 1) {
          return (
            <div>
              已添加{row.online_subsidy_goods_count}个商品
              <el-button style={{ marginLeft: '5px' }} type="text" on-click={() => vm.showGoods(row, 'online')}>查看线上国补商品</el-button>
            </div>
          )
        }
        if (row.subsidy_type == 2) {
          return (
            <div>
              已添加{row.offline_subsidy_goods_count}个商品
              <el-button style={{ marginLeft: '5px' }} type="text" on-click={() => vm.showGoods(row, 'offline')}>查看线下国补商品</el-button>
            </div>
          )
        }
      }
    },
    {
      name: '国补类型',
      key: 'subsidy_type',
      minWidth: 80,
      render: (h, {row}) => {
        return <span>{row.subsidy_type == 1 ? '线上' : row.subsidy_type == 2 ? '线下' : ''}</span>
      }
    },
    {
      name: '是否启用',
      key: 'open_status',
      minWidth: 80,
      render: (h, {row}) => {
        return <el-switch value={row.open_status} active-value="1" inactive-value='2' on-change={() => vm.handleSettingChange(row)}></el-switch>
      }
    },
  ],
  actions: [
    {
      name: '编辑',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: async (rows) => {
          useDialog(null, {
            title: `编辑国补支持店铺及品类`,
            width: '30%',
            orgData: rows[0],
            component: () => import('../comps/createForm.vue'),
            actions: commonAction
          }).then(async (arg) => {
            if(arg) {
              const params = {
                ...arg,
                is_update: true
              }
              console.log(params, 'edit_arg')
              try {
                await setGovItems(params)
                vm.$message.success('保存成功')
                vm.refresh()
              } catch (error) {
                console.log(error)
              }
            }
          })
        }
      }
    },
    {
      name: '删除',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: async (rows) => {
          MessageBox.confirm('请确认是否删除当前数据？', '提示').then(async () => {
            const distributor_info = [{
              distributor_id: rows[0].distributor_id,
              subsidy_type: rows[0].subsidy_type
            }]
            await batchDelete({ distributor_info })
            vm.$message.success('删除成功')
            vm.refresh()
          })
        }
      }
    },
  ]
})
